import { render, staticRenderFns } from "./SurveyDone.vue?vue&type=template&id=2dd7efd9&scoped=true"
import script from "./SurveyDone.vue?vue&type=script&lang=js"
export * from "./SurveyDone.vue?vue&type=script&lang=js"
import style0 from "./SurveyDone.vue?vue&type=style&index=0&id=2dd7efd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7efd9",
  null
  
)

export default component.exports